import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
//Limitless imports
import { LoginButton } from "@limitless/portal";
const useStyles = makeStyles(() => ({
  dialogContainer: {
    padding: "0px 30px 30px 30px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    color: "black"
  },
  buttonStyles: {
    marginTop: 20
  },
  iconContainer: {
    padding: 0,
    textAlign: "end"
  },
  icon: {
    color: "black"
  }
}));
const ClosedOverlay = ({
  content,
  open,
  handleCloseDailogClick,
  handleSignUpButtonClick
}) => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(Dialog, {
    onClose: handleCloseDailogClick,
    open: open,
    fullWidth: true
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    className: classes.iconContainer
  }, /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "close button",
    onClick: handleCloseDailogClick,
    size: "large"
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    className: classes.icon
  }))), /*#__PURE__*/React.createElement(DialogContent, {
    className: classes.dialogContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, content.closedHeader), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    gutterBottom: true
  }, content.closedSubHeader), /*#__PURE__*/React.createElement(LoginButton, {
    onClick: handleSignUpButtonClick,
    className: classes.buttonStyles
  }, content.closedButtonLabel)));
};
ClosedOverlay.propTypes = {
  content: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  handleCloseDailogClick: PropTypes.func.isRequired,
  handleSignUpButtonClick: PropTypes.func
};
export default ClosedOverlay;